import { render, staticRenderFns } from "./SavingWarningModal.vue?vue&type=template&id=3eba7996&scoped=true"
import script from "./SavingWarningModal.vue?vue&type=script&lang=ts"
export * from "./SavingWarningModal.vue?vue&type=script&lang=ts"
import style0 from "./SavingWarningModal.vue?vue&type=style&index=0&id=3eba7996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eba7996",
  null
  
)

export default component.exports